import { connect } from 'react-redux'
import { AllState } from '../../../../../store'
import PageHeader, {
  HeaderContent,
  HeaderDivider,
  HeaderGroup,
  IconGroup,
} from '../../../../components/headers/HeaderBar/PageHeader'
import { DateTerm } from '../../../../../utils/date'
import SettingSpeedDial from '../../../../components/headers/HeaderBar/SettingSpeedDial'
import { ToolbarToggleValue } from '../../../../components/toolbars/Toolbar/ToolbarToggle'
import { MonthRangeSelector } from '../MonthRangeSelector'
import UserShiftButtonGroup, {
  UserShiftButtonGroupProps,
} from '../../../ActualWorkingHoursConfirm/components/Header/UserShiftButtonGroup'
import { intl } from '../../../../../i18n'
import styled from 'styled-components'
import SplitButton, {
  SplitButtonProps,
} from '../../../../components/buttons/SplitButton'
import ReloadButton from '../../../../containers/BulkSheetView/components/header/ReloadButton'
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded'
import IconButton from '@mui/material/IconButton'
import Badge from '@mui/material/Badge'
import { colorPalette } from '../../../../style/colorPalette'
import { FilterInfo } from '../FilterPanel/hooks/useFilterState'

interface OwnProps {
  loading: boolean
  onSubmit: () => void
  onCancel: () => void
  dateTerm: DateTerm
  onSearch: (dateTerm: DateTerm) => void
  onClickExport: () => void
  toolbar: ToolbarToggleValue | undefined
  onChangeToolbar: (value: ToolbarToggleValue | undefined) => void
  rowHeight: number
  onChangeRowHeight: (value: number) => void
  splitButtonProps: SplitButtonProps
  onOpenFilterPanel: () => void
  filterInfo: FilterInfo
}

interface StateProps {
  notEdited: boolean
}

const TotalSpan = styled('span')({
  whiteSpace: 'nowrap',
})

const FilterStatusLabel = styled('span')({
  whiteSpace: 'nowrap',
  fontSize: '12px',
  color: '#666',
  marginLeft: '4px',
})

type Props = OwnProps & StateProps & UserShiftButtonGroupProps

const TaskActualWorkApproveHeader = (props: Props) => {
  const isFilterActive = props.filterInfo.isFilterActive

  return (
    <PageHeader>
      <HeaderContent>
        <HeaderGroup>
          <ReloadButton onReload={props.onCancel} />
        </HeaderGroup>
        <HeaderGroup>
          <MonthRangeSelector
            dateTerm={props.dateTerm}
            onSearch={props.onSearch}
          />
        </HeaderGroup>
        <HeaderGroup>
          <Badge
            variant="dot"
            invisible={!isFilterActive}
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: colorPalette.pink[5],
                right: 4,
                top: 4,
              },
            }}
          >
            <IconButton onClick={props.onOpenFilterPanel} size="small">
              <FilterListRoundedIcon />
            </IconButton>
          </Badge>
          <FilterStatusLabel>{props.filterInfo.filterLabel}</FilterStatusLabel>
        </HeaderGroup>
        <HeaderGroup>
          <UserShiftButtonGroup
            userName={props.userName}
            currentIndex={props.currentIndex}
            totalCount={props.totalCount}
            onPagingUser={props.onPagingUser}
          />
        </HeaderGroup>
        <HeaderGroup>
          <TotalSpan>
            {intl.formatMessage(
              { id: 'search.hitsTotal' },
              { hit: props.currentIndex, total: props.totalCount }
            )}
          </TotalSpan>
        </HeaderGroup>
        <HeaderDivider />
        <HeaderGroup>
          <IconGroup>
            <SettingSpeedDial
              onClickExport={props.onClickExport}
              rowHeight={props.rowHeight}
              onClickChangeRowHeight={props.onChangeRowHeight}
            />
          </IconGroup>
        </HeaderGroup>
        <HeaderDivider />
        <SplitButton
          options={props.splitButtonProps.options}
          disabled={props.splitButtonProps.disabled}
          buttonStyle={{ height: '28px' }}
        ></SplitButton>
      </HeaderContent>
    </PageHeader>
  )
}

const mapStateToProps = (state: AllState) => ({
  notEdited: !state.hasRequiredSaveData.hasRequiredSaveData,
})

export default connect(mapStateToProps)(TaskActualWorkApproveHeader)
